import { Avatar, Button, Paper, Text } from "@mantine/core";
import { useEffect, useState } from "react";
import UserInfoForm from "./UserInfoForm/UserInfoForm";
import LoadingSpinner from "../../LoadingSpinner/LoadingSpinner";
import user from "../../../assets/img/user.png";

export function UserInfoAction() {
  const [editing, setEditing] = useState(false);
  const [loading, setLoading] = useState(false);
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");

  useEffect(() => {
    async function fetchUser() {
      try {
        setLoading(!false); // fok u Luke
        setLoading(true); // You're welcome Alex :)
        const response = await fetch(
          window.location.origin + "/server/client_service/user"
        );
        const resData = await response.json();
        setFirstName(resData.first_name);
        setLastName(resData.last_name);
        setEmail(resData.email);
        console.log("userinfo data is", resData);

        if (!response.ok) {
          throw new Error("Failed to fetch user info");
        }
        setLoading(false);
      } catch (error) {
        console.log(error);
      }
    }

    fetchUser();
  }, []);

  function handleEditProfile() {
    console.log("editing profile");
    setEditing(true);
  }

  function handleDiscard() {
    console.log("discarding");
    setEditing(false);
  }

  function handleUserInfoUpdate(first: string, last: string) {
    setFirstName(first);
    setLastName(last);
    setEditing(false);
  }

  return !loading ? (
    <Paper radius="md" withBorder p="lg" bg="var(--mantine-color-body)">
      <Avatar size={120} radius={120} mx="auto" src={user}/>
      <Text ta="center" fz="lg" fw={500} mt="md">
        {firstName} {lastName}
      </Text>

      {!editing ? (
        <>
          <Text ta="center" c="dimmed" fz="sm">
            {email}
          </Text>
          <Button
            variant="outline"
            fullWidth
            mt="md"
            onClick={handleEditProfile}
            style={{ borderColor: "#00ddb3", color: "#00ddb3" }}
          >
            Edit Profile
          </Button>
        </>
      ) : (
        <UserInfoForm
          firstName={firstName}
          lastName={lastName}
          handleDiscard={handleDiscard}
          updateUserInfo={handleUserInfoUpdate}
        />
      )}
    </Paper>
  ) : (
    <LoadingSpinner size="sm" color="blue" />
  );
}
